export default "__VITE_ASSET__BPe_lW9D__"